module.exports = __webpack_public_path__ + "static/user4-41530a7019a90cc32b995758eabc5a9a.jpg";